import {
  getXeroBankAccountCodesActionTypes,
  getXeroBankAccountMappingsActionTypes,
  getXeroBankAccountsActionTypes, putXeroBankAccountMappingsActionTypes,
  setActiveXeroBankAccountsActionType,
  updateXeroBankAccountMappingRecordActionType,
} from './actions';

const initialState = {
  accounts: [],
  selectedAccount: undefined,
  xeroAccounts: [],
  xeroMappings: [],
  xeroMappingsLoadingState: undefined,
  xeroMappingsPushState: undefined,
};

const handleGetXeroBankAccountsSuccess = (state, { accounts }) => ({
  ...state,
  accounts,
});

const handleGetXeroBankAccountMappingsSuccess = (state, action) => ({
  ...state,
  xeroMappings: action.payload,
  backupXeroMappings: action.payload,
  xeroMappingsLoadingState: 'success',
});

const handleGetXeroBankAccountMappingsRequest = (state) => ({
  ...state,
  xeroMappingsLoadingState: 'progress',
});

const handleGetXeroBankAccountCodesSuccess = (state, action) => ({
  ...state,
  xeroAccounts: action.payload,
});

const handleSetActiveXeroBankAccount = (state, action) => ({
  ...state,
  selectedAccount: action.account,
});

const handleUpdateXeroBankAccountMappingRecord = (state, { record, mapping }) => ({
  ...state,
  xeroMappings: state.xeroMappings.map((row) => {
    if (row === record) {
      row.account_code = mapping.account_code;
      row.account_name = mapping.account_name;
    }
    return row;
  }),
});

const handlePutXeroBankAccountMappingsRequest = (state) => ({
  ...state,
  xeroMappingsPushState: 'progress',
});

const handlePutXeroBankAccountMappingsSuccess = (state) => ({
  ...state,
  xeroMappingsPushState: 'success',
});

const handlePutXeroBankAccountMappingsError = (state) => ({
  ...state,
  xeroMappingsPushState: 'error',
});

export default (state = initialState, action) => {
  const handlers = {
    [getXeroBankAccountsActionTypes.success]: handleGetXeroBankAccountsSuccess,
    [getXeroBankAccountMappingsActionTypes.success]: handleGetXeroBankAccountMappingsSuccess,
    [getXeroBankAccountMappingsActionTypes.request]: handleGetXeroBankAccountMappingsRequest,
    [getXeroBankAccountCodesActionTypes.success]: handleGetXeroBankAccountCodesSuccess,
    [setActiveXeroBankAccountsActionType]: handleSetActiveXeroBankAccount,
    [updateXeroBankAccountMappingRecordActionType]: handleUpdateXeroBankAccountMappingRecord,
    [putXeroBankAccountMappingsActionTypes.request]: handlePutXeroBankAccountMappingsRequest,
    [putXeroBankAccountMappingsActionTypes.success]: handlePutXeroBankAccountMappingsSuccess,
    [putXeroBankAccountMappingsActionTypes.error]: handlePutXeroBankAccountMappingsError,
  };
  return handlers[action.type] ? handlers[action.type](state, action) : state;
};
